module.exports = __webpack_public_path__ + "static/img/ranqi3.80b8074b.png";